type QuestionWithAnswer = {
  id: string;
  question: string;
  type: string;
  answers?: string[] | null;
  choices?: { choice: string; count: number }[] | null;
};

export const MIN_AI_COMMENT_LENGTH = 3; // minimum length of a comment to be considered for AI keywords generation

export const convertQuestionAnswersToTextVersionForGPT = (answers: QuestionWithAnswer[]) =>
  answers.reduce((acc, q) => {
    acc += `${q.question} (${q.type}) [${q.id}]\n`;
    if (q.answers) {
      // answers means free text
      acc += 'Answers:\n';
    } else {
      // no answers means choices
      acc += 'Choices:\n';
    }
    q.answers?.forEach((a) => {
      acc += `- ${a.replace(/(\r\n|\r|\n)/g, '; ')}\n`;
    });
    q.choices?.forEach((a) => {
      acc += `- ${a.choice} - ${a.count} answers\n`;
    });

    acc += '\n';
    return acc;
  }, '');

export const getMessagesForAiSummary = (questionAnswersText: string, systemMessage: string, languageCode?: string) => [
  {
    role: 'system',
    content: systemMessage.replace('%LANGUAGE_CODE%', languageCode ?? 'en'),
  },
  { role: 'user', content: questionAnswersText },
];

/**
 * Extracts the "explanation" string from a (possibly incomplete) JSON object response.
 * Returns the input unchanged when it does not look like JSON with an explanation field.
 */
export const extractExplanationFromPartialJson = (text: string): string => {
  const explanationMatch = text.match(/"explanation"\s*:\s*"/);
  if (!explanationMatch || explanationMatch.index === undefined) {
    return text;
  }

  const startIndex = explanationMatch.index + explanationMatch[0].length;
  let raw = '';
  let i = startIndex;
  while (i < text.length) {
    const char = text[i];
    if (char === '\\') {
      if (i + 1 >= text.length) {
        raw += char;
        break;
      }
      raw += text.slice(i, i + 2);
      i += 2;
      continue;
    }
    if (char === '"') {
      break;
    }
    raw += char;
    i++;
  }

  try {
    return JSON.parse(`"${raw}"`);
  } catch {
    return raw.replace(/\\n/g, '\n').replace(/\\"/g, '"').replace(/\\t/g, '\t').replace(/\\\\/g, '\\');
  }
};

export const formatStringForEmbeddings = (str: string) =>
  str
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s.,?!]/gu, ' ')
    .replaceAll('\n', ' ')
    .replaceAll('  ', ' ')
    .trim();
